import React from "react";
import { Routes, Route } from "react-router-dom";
import SubPage from "components/pages/team/sub-pages";
import type { TTeam } from "components/team/helpers/team-types-helper";
import { PermissionGuard } from "components/permissions";
import { Pages } from "components/pages";
import Team from "components/team";

interface ITeamRouteProps
{
  team: TTeam | undefined;
}


const TeamRoute: React.FC<ITeamRouteProps> = ({ team }) =>
{
  return (
    <PermissionGuard
      permission={Team.Const.permissions.VIEW}
      fallback={<Pages.Page403 />}
    >
      <Routes>
        <Route path="/" element={<SubPage.OverView team={team} />} />
      </Routes>
    </PermissionGuard>
  );
};

export default TeamRoute;
